import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconCash = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 26 26'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>{t('Cutlery')}</title>
    <path
      fill={fill}
      d='M5.361.5c2.685 0 4.861 2.85 4.861 6.367 0 2.55-1.145 4.751-2.798 5.767l.017 11.86c0 .526-.417.957-.948 1.002l-.095.004-1.7-.002c-.54-.001-.983-.399-1.034-.908l-.005-.096-.018-11.67C1.805 11.914.5 9.59.5 6.867.5 3.351 2.676.5 5.361.5zm14.236 0c.404 0 .799.041 1.18.12v8.805h1.575v-8.23A6.05 6.05 0 0125.5 6.533c0 2.537-1.532 4.708-3.703 5.6l.018 11.92c-.001.558-.468 1.007-1.043 1.006l-1.7-.002c-.573-.001-1.039-.45-1.04-1.004l-.017-11.707c-2.492-.707-4.32-3.042-4.32-5.813 0-1.516.547-2.902 1.451-3.962a5.958 5.958 0 011.539-1.286v8.141h1.574V.655c.43-.101.878-.155 1.338-.155z'
    />
  </svg>
)

export default Icon(IconCash)
